import { useEffect } from "react";

const SEO = ({ pageTitle }) => {
  useEffect(() => {
    document.title = pageTitle + " - MR Kahlon Ltd";
  }, []);
};

export default SEO;